import React from 'react'
import PropTypes from 'prop-types'
import { head } from 'ramda'
import { isString, isObject } from 'utils/types'
import { classNames } from 'utils/utils'
import { Link as ReactRouterDomLink } from 'react-router-dom'
import withStyle from './Link.style.js'

const FORWARD_SLASH = '/'

const addLeadSlash = (uri) => {
  if (head(uri) !== FORWARD_SLASH) {
    return `/${uri}`
  }
  return uri
}

const Link = ({ className, to, children, onClick, ...rest }) => {
  const convertedToProp = {
    pathname: isString(to) && addLeadSlash(to),
    ...(isObject(to) && to),
  }

  return (
    <ReactRouterDomLink
      to={convertedToProp}
      onClick={onClick}
      className={classNames(className, 'link')}
      {...rest}
    >
      {children}
    </ReactRouterDomLink>
  )
}

Link.propTypes = {
  /** Make sure to comment */
  /** Classname */
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  /** add more props for Link as needed */
}

export default withStyle(Link)
